import React from 'react';
import ScrollIntoView from './ScrollIntoView';
import getDisplayName from './helpers/getDisplayName';

var withScroll = function withScroll(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$propId = options.propId,
      propId = _options$propId === undefined ? function (props) {
    return props && props.location && props.location.hash;
  } : _options$propId,
      _options$alignToTop = options.alignToTop,
      alignToTop = _options$alignToTop === undefined ? true : _options$alignToTop;

  var WithScroll = function WithScroll(props) {
    return React.createElement(
      ScrollIntoView,
      { id: propId(props), alignToTop: alignToTop },
      React.createElement(Component, props)
    );
  };

  WithScroll.displayName = 'withScroll(' + getDisplayName(Component) + ')';

  return WithScroll;
};

export default withScroll;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rrc/es/withScroll.js
// module id = 544
// module chunks = 0